// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>10</span>&nbsp;&nbsp;But you, O Lord, be merciful to me&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and raise me up, that I may reward them.<br> </p> </div></div>";
// Exports
module.exports = code;